module.exports = __webpack_public_path__ + "static/q4-3a1b84c81ef12ec71b53fc01b6fecbc4.png";